// @flow strict
import React, { useEffect, useState } from "react";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { CountryDropdown } from "react-country-region-selector";
import ReactCountryFlag from "react-country-flag";
import { Input } from "reactstrap";
import CountrySelect from "./CountrySelect";

export const extractPhoneDetails = ( phoneNumber ) =>
{
    if ( !phoneNumber )
    {
        return { country: "BJ", countryCode: "+229", number: "" };
    }
    let phone_number = phoneNumber.replace( /\s/g, "" );

    try
    {
        const phoneNumberObj = parsePhoneNumberFromString( phone_number );

        if ( phoneNumberObj )
        {
            const country = phoneNumberObj.country || null;
            let countryCode = phoneNumberObj.countryCallingCode || null;
            let number = phoneNumberObj.nationalNumber || null;
            if ( !countryCode.startsWith( "+" ) )
            {
                countryCode = "+" + countryCode;
            }
            return { country, countryCode, number };
        } else
        {
            return { country: "BJ", countryCode: "+229", number: phone_number };
        }
    } catch ( error )
    {
        console.error(
            `Erreur lors de la conversion du contact ${ phone_number }: `,
            error
        );
        return { country: "BJ", countryCode: "+229", number: phone_number };
    }
};

function validatePhoneNumber ( phoneNumber, countryCode )
{
    const phoneNumberObj = parsePhoneNumberFromString( phoneNumber, countryCode );

    if ( phoneNumberObj )
    {
        const isValid = phoneNumberObj.isValid();
        const formattedNumber = phoneNumberObj.formatInternational();
        const country = phoneNumberObj.country;

        return {
            isValid,
            formattedNumber,
            country,
        };
    } else
    {
        return {
            isValid: false,
            formattedNumber: null,
            country: null,
        };
    }
}

function NewPhoneInputComponent ( {
    Value,
    setValue,
    showcallingCode = true,
    showDivider = false,
    showCaret = false,
    required = true,
} )
{
    const [ border, setBorder ] = useState( { color: "", width: 0 } );
    const [ telephone, setTelephone ] = useState( "" );
    const [ focus, setFocus ] = useState( false );

    const [ countryCode, setCountryCode ] = useState( "BJ" );
    const [ country, setCountry ] = useState( {
        cca2: "BJ",
        callingCode: "+229",
    } );

    const onSelectCountry = ( countryName ) =>
    {
        const countryData = getCountryDataByName( countryName );
        if ( countryData )
        {
            setFocus( true );
            setCountryCode( countryData.cca2 );
            setCountry( {
                cca2: countryData.cca2,
                callingCode: countryData.callingCode,
            } );

            if ( telephone )
            {
                validateNumber( telephone, countryData.cca2 );
            }
        }
    };

    const validateNumber = ( tel, code ) =>
    {
        if ( tel && code )
        {
            const result = validatePhoneNumber( tel, code );

            if ( !result.isValid )
            {
                setBorder( { color: "red", width: 2 } );
            } else
            {
                setBorder( { color: "", width: 0 } );
                setValue( result.formattedNumber.replaceAll( " ", "" ) );
            }
        } else
        {
            setBorder( { color: "", width: 0 } );
        }
    };

    useEffect( () =>
    {
        const tel = extractPhoneDetails( Value );
        setTelephone( tel.number );
        setCountryCode( tel.country );
        setCountry( {
            cca2: tel.country,
            callingCode: tel.countryCode,
        } );
        validateNumber( tel.number, tel.country );
    }, [ Value ] );

    return (
        <div style={ { flex: 1 } }>
            <div
                style={ {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "white",
                    borderColor: border.color,
                    borderWidth: border.width,
                    padding: "8px",
                    borderRadius: "4px",
                } }
            >
                {/* Sélection du pays */ }
                {/* <CountryDropdown
                    value={ country.cca2 }
                    onChange={ ( val ) => onSelectCountry( val ) }
                    style={ {
                        marginRight: "8px",
                        padding: "4px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                    } }
                /> */}
                <CountrySelect
                    onSelectCountry={ ( text ) =>
                    {
                        console.log( "country: ", text )
                    } }
                    style={ {
                        marginRight: "8px",
                        padding: "4px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                    } }
                />

                {/* Champ de saisie du numéro de téléphone */ }
                <Input
                    name="telephone"
                    id="telephone"
                    className="form-control"
                    placeholder={ "Entrez le telephone de reduction" }
                    type="text"
                    validate={ {
                        required: { value: true },
                    } }
                    autoFocus={ focus }
                    value={ telephone }
                    onChange={ ( e ) =>
                    {
                        setTelephone( e.target.value );
                        validateNumber( e.target.value, countryCode );
                    } }
                    style={ {
                        flex: 1,
                        marginLeft: "8px",
                        //     border: "none",
                        //     outline: "none",
                    } }
                />
            </div>
        </div>
    );
}

// Fonction pour obtenir les données du pays par son nom
const getCountryDataByName = ( countryName ) =>
{
    // Vous pouvez utiliser une bibliothèque comme `country-data` pour obtenir les données du pays
    // ou définir manuellement une liste de pays avec leurs codes et indicatifs.
    const countries = [
        { name: "Benin", cca2: "BJ", callingCode: "+229" },
        { name: "France", cca2: "FR", callingCode: "+33" },
        { name: "United States", cca2: "US", callingCode: "+1" },
        // Ajoutez d'autres pays ici
    ];

    return countries.find( ( c ) => c.name === countryName );
};

export default NewPhoneInputComponent;